import * as Sentry from "@sentry/vue";
import { createPinia } from "pinia";
import { createApp } from "vue";

import "@/assets/styles/main.css";
import "virtual:vite-svg-2-webfont.css";

import App from "@/App.vue";
import { config } from "@/config";
import { router } from "@/router";

const pinia = createPinia();
const appContainer = document.getElementById("app");
if (appContainer !== null) {
  const app = createApp(App);

  if (import.meta.env.PROD && config.vueSentryDsn) {
    Sentry.init({
      app,
      dsn: config.vueSentryDsn,
      environment: config.vueSentryEnvironment,
      release: config.vueSentryRelease,
    });
  }

  app.use(pinia);
  app.use(router);
  app.mount(appContainer);
}
